export const Bio = {
  name: "Samruddhi",
  roles: [
    "Data Analyst",
  ],
  description:
    "I work hard, stay adaptable, and take on challenges to shape a strong career path.",
  github: "https://github.com/samruddhi4040",
  resume:
    "https://drive.google.com/file/d/1A4fHoeL8LNqw-zuRhWw83aWtyjfjVSrn/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/samruddhi-bhosale-73567926a/",

  linktree:"https://linktr.ee/samruddhi4040",

  kaggle:"https://www.kaggle.com/samruddhi4040"
};

export const skills = [
  {
    title: "Data Science",
    skills: [
      {
        name:"ML & AI",
        image:
        "https://res.cloudinary.com/dj24clwc2/image/upload/v1713949337/images__2_-removebg-preview_zuhfso.png"
      },
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name:"R",
        image:
        "https://res.cloudinary.com/dj24clwc2/image/upload/v1713948278/images__1_-removebg-preview_1_vqnx12.png"
      },
      {
        name:"Anaconda",
        image:
        "https://res.cloudinary.com/dj24clwc2/image/upload/v1713949912/images__2_-removebg-preview_1_pbgadi.png"
      },
      {
        name: "Jupyter",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/3/38/Jupyter_logo.svg/1767px-Jupyter_logo.svg.png",
      },
      {
        name: "Google Colab",
        image:
          "https://res.cloudinary.com/dj24clwc2/image/upload/v1713947319/co-removebg-preview_hmrrme.png",
      },
      {
        name:"Deep Learning",
        image:
        "https://res.cloudinary.com/dj24clwc2/image/upload/v1713952938/images__5_-removebg-preview_t6vquw.png"
      },
     {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name:"Tensorflow",
        image:
        "https://res.cloudinary.com/dj24clwc2/image/upload/v1713954591/tensorflow-removebg-preview_zheevl.png"
      }
    ],
  },
  {
    title:"Data Analysis",
    skills: [
      {
        name:"Power BI",
        image:
        "https://res.cloudinary.com/dj24clwc2/image/upload/v1713950598/power_bi-removebg-preview_gjxtnt.png"
      },
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name:"Excel",
        image:
        "https://res.cloudinary.com/dj24clwc2/image/upload/v1713950877/xl-removebg-preview_lrd26d.png"
      },
      {
        name:"Anaconda",
        image:
        "https://res.cloudinary.com/dj24clwc2/image/upload/v1713949912/images__2_-removebg-preview_1_pbgadi.png"
      },
      {
        name: "Jupyter",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/3/38/Jupyter_logo.svg/1767px-Jupyter_logo.svg.png",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "Microsoft SQL Server",
        image:
          "https://res.cloudinary.com/dj24clwc2/image/upload/v1713951141/32a03aee0c76419ec5bde950a62883bc-removebg-preview_ba5lui.png",
      },
     
      {
        name:"Tableau",
        image:
        "https://res.cloudinary.com/dj24clwc2/image/upload/v1713954409/table-removebg-preview_c9dfgt.png"
      }
    ]
  },
  {
    title: "Web Development | Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Redux",
        image:
          "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
        
      {
        name: "Material UI",
        image:
          "data:image/png;base64,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",
      },
    {
      name:"Font Awesome",
      image:
      "https://res.cloudinary.com/dj24clwc2/image/upload/v1713950058/images__3_-removebg-preview_1_ktfhrq.png"
    }
    ],
  },
  {
    title: "Web Development | Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Express Js",
        image:
          "data:image/png;base64,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",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "Postgresql",
        image: "https://www.postgresql.org/media/img/about/press/elephant.png",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
    ],
  },
  {
    title: "Development & Design Tools",
    skills: [
      {
        name: "Git",
        image:
          "https://e7.pngegg.com/pngimages/713/558/png-clipart-computer-icons-pro-git-github-logo-text-logo-thumbnail.png",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Vercel",
        image:
          "https://res.cloudinary.com/dj24clwc2/image/upload/v1727085984/images_r0plqo.png",
      },
      {
        name: "VS Code",
        image:
          "https://res.cloudinary.com/dj24clwc2/image/upload/v1713954791/vscode-removebg-preview_wvsppq.png",
      },
  
      {
        name: "Canva",
        image:
          "https://res.cloudinary.com/dj24clwc2/image/upload/v1713948035/images-removebg-preview_1_ub9a8f.png",
      },
      {
        name: "Figma",
        image:
          "https://s3-alpha.figma.com/hub/file/1481185752/fa4cd070-6a79-4e1b-b079-8b9b76408595-cover.png",
      },
    ],
  },
  {
    title: "Android",
    skills: [
      {
        name: "Java",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
      },
      
    
      {
        name: "XML",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSBMw6_RdwKQ9bDFfnKDX1iwMl4bVJEvd9PP53XuIw&s",
      },
      {
        name: "Android Studio",
        image:
          "https://developer.android.com/static/studio/images/new-studio-logo-1_1920.png",
      },
    ],
  },
  {
    title: "Cloud",
    skills: [
     
      {
        name: "Google Cloud",
        image:
          "https://static-00.iconduck.com/assets.00/google-cloud-platform-logo-icon-2048x1824-pg4wzspq.png",
      },
    
    ],
  },
];
export const experiences = [
  {
    id: 0,
    img: "https://res.cloudinary.com/dj24clwc2/image/upload/v1713957494/oasis-removebg-preview_conqah.png",
    role: "Data Science Intern",
    company: "Oasis Infobyte",
    date: "Sept 2023 - Oct 2023",
    desc: "1.Trained car price using decision tree 'regression algorithm' prediction model. 2.Used machine learning to train spam detector to recognize and classify emails into spam and non-spam. 3.Trained a machine learning model that can learn from measurements of iris species and classify them accordingly. ",
    skills: [
      "Data Science",
      "Data Visualization",
      "Kaggle Notebook",
      "Machine Learning"
    ],
  },
  {
    id: 1,
    img: "https://res.cloudinary.com/dj24clwc2/image/upload/v1713958406/codeclause_logo_l1yaej.jpg",
    role: "Python Intern",
    company: "Code Clause",
    date: "Aug 2023 - Aug 2023",
    desc: "1.Generated  URL shortener that shortens any provided URL for better ease of access. 2.Generated a Music Player that allows music to be added, shuffle through playlists, play & pause songs through user-defined playlist.",
    skills: [
      "Python",
      "Artificial Intelligence",
      "VSCode",
      "Jupyter",
    ],
    doc: "https://drive.google.com/file/d/1CqLn5pxXeI74_2mNlxe8lueueG5FS4UB/view?usp=sharing",
  },
  {
    id: 2,
    img: "https://res.cloudinary.com/dj24clwc2/image/upload/v1713958307/bharat_intern_logo_asowwt.jpg",
    role: "Artificial Intelligence Intern",
    company: "Bharat Intern",
    date: "Jul 2023 - Aug 2023",
    desc: "1.Developed an auto-translator tool that would translate between 2 languages at a time. 2.Developed an auto-correct tool that would replace the incorrect word with a nearby correct word.",
    skills: [
      "Artificial Intelligence",
      "Python",
      "Regression algorithm"
    ],
    doc: "https://drive.google.com/file/d/1bD7IlagvQ9t-HY_gwkPxXcwDdiT7Ajiq/view?usp=sharing",
  },
  {
    id: 3,
    img: "https://res.cloudinary.com/dj24clwc2/image/upload/v1713958816/images_6_odv4k8.png",
    role: "Artificial Intelligence Intern",
    company: "Infosys Springboard",
    date: "Jan 2023 - May 2023",
    desc: "1.Worked on 'HONQPGen'-AI based Hands-On Question Paper Generator. 2.Developed a Python program to parse Java source code & extract main methods, instance variables using Abstract Syntax Tree (AST). 3.Generated UML class diagrams from Java source code using PlantUML.",
    skills: [
      "Artificial Intelligence",
      "Python",
      "HONQPGen"
    ],
    doc: "https://drive.google.com/file/d/12JksHrFIPPmCiEG8wR2zxrMldcKxwQOB/view?usp=sharing",
  },
];

export const education = [
  {
    id: 0,
    img: "https://res.cloudinary.com/dj24clwc2/image/upload/v1713961149/pendu_wasq2m.jpg",
    school: "K.V.Pendharkar College of Arts, Science & Commerce",
    date: "June 2021 - May 2024",
    grade: "8.9 CGPA",
    desc: "I am a fresh graduate in Bachelor's degree in Information Technology at K.V.Pendharkar College of Arts, Science & Commerce, Dombivali. I have completed 6 semesters and have a CGPA of 8.1 as of Sem 6. ",
    degree: "Bachelor of Science - BSc., Information Technology",
  },
  {
    id: 1,
    img: "https://res.cloudinary.com/dj24clwc2/image/upload/v1713961806/laksya_m41ety.jpg",
    school: "Shri Krishna Lakshya Prep High School & Junior College",
    date: "Jun 2019 - Mar 2021",
    grade: "86.5%",
    desc: "I completed my class 12 High School education at Shri Krishna Lakshya Prep High School & Junior College, Kalyan, where I studied Science with Information Technology.",
    degree: "HSC(XII), Science with Computer",
  },
  {
    id: 2,
    img: "https://res.cloudinary.com/dj24clwc2/image/upload/v1713962005/clms_ufjtii.jpg",
    school: "Chandresh Lodha Memorial School, Dombivali",
    date: "Jun 2018 - Mar 2019",
    grade: "77%",
    desc: "I completed my class 10 education at CLMS, Dombivali, where I studied Science with Computer Application.",
    degree: "SSC(X), Science with Computer",
  },
];

export const projects = [
  {
    id: 0,
    title: "Translation Tool",
    date: "July 2023 - Aug 2023",
    description:
      "Translator AI which translates between languages. Here, I've chosen to translate between 3 languages (Hindi, Marathi, English). I've used Jupyter notebook to write down the code.",
    image:
      "https://res.cloudinary.com/dj24clwc2/image/upload/v1718711889/translator_tool_ggz2mt.png",
    tags: ["Python",
       "Artificial Intelligence",
      "Jupyter",
      "Google Colab"
    ],
    category: "aiml",
    github: "https://github.com/samruddhi4040/BharatIntern_Translator-Tool",
    webapp: "https://colab.research.google.com/drive/1iiwnr6LE1ySl75QNc5fyd5qjkCA37iuE?usp=sharing",
    type:"projects"
  },
  {
    id: 1,
    title: "URL Shortener",
    date: "July 2023 - Aug 2023",
    description:
      "The code uses a random string generator to create short URLs. The code also stores the original URL and the short URL. This allows users to easily access the original URL by clicking on the short URL. The code is efficient and scalable, making it a good fit for a production environment.",
    image:
      "https://res.cloudinary.com/dj24clwc2/image/upload/v1718714054/url_lvludg.png",
    tags: [
      "Python",
      "Artificial Intelligence",
    "URL Shortener",
    "Google Colab"
    ],
    category: "aiml",
    github: "https://github.com/samruddhi4040/CodeClause_URL-Shortener",
    webapp: "https://colab.research.google.com/drive/1XbRKk-itYdtXZ0DFr6JfUcVGOm8Y26tO?usp=sharing",
    type:"projects"
  },
  {
    id: 2,
    title: "Music Player",
    date: "July 2023 - Aug 2023",
    description:
      <div>
   The music player can play, pause, and stop songs from a user-defined playlist. The project was written in VS code. 
   <p>The music player uses pygame & tkinter library to read and parse MP3 files.The Pygame library is used to play the music files. </p>
   <p>The Tkinter library is used to create the user interface. </p>
   <p>The project is modularized into different functions, which makes it easy to maintain and extend. </p><p>The project is well-documented, which makes it easy to understand and use.</p>
      </div>
    ,image:
      "https://res.cloudinary.com/dj24clwc2/image/upload/v1718797378/Screenshot_655_el9iuu.png",
    tags: ["Python","Music Player", "Pygame", "Tkinter"],
    category: "aiml",
    github: "https://github.com/samruddhi4040/CodeClause_Music-Player",
    webapp: "https://colab.research.google.com/drive/1tdHQ0GrwCcrTA5zpQcH7TuE1GiC_WZI1?usp=sharing",
    type:"projects"
  },
  {
    id: 3,
    title: "Unemployment Analysis using Python",
    date: "Aug 2023 ",
    description:
     <div>
       We have seen a sharp increase in the unemployment rate during Covid-19, so analyzing the unemployment rate can be a good data science project. <p>Unemployment is measured by the unemployment rate which is the number of people who are unemployed as a percentage of the total labour force. </p><p>The task was to analyze unemployment rate in India using Python.</p><p> Packages such as pandas, numpy & seaborn were put to use for the task. I've also uploaded the dataset used by me for completing this task.</p><p> For this, I first had to checkout whether the dataset has any inconsistency and then using necessary packages, libraries and other data visualization tools.</p> <p>To determine the unemployment rate, the data was categorized on the basis on states, regions (North / South / West / East) & on their areas (rural or urban).</p>",
      </div>
    ,image:
      "https://res.cloudinary.com/dj24clwc2/image/upload/v1718798135/unemploy_c2x4a6.png",
    tags: ["Python","Unemployment analysis", "Google Colab"],
    category: "data analysis",
    github: "https://github.com/samruddhi4040/Oasis-Infobye_Unemployment-analysis-using-Python",
    webapp: "https://colab.research.google.com/drive/1YgxUzNNrwmyPyJDIki3btPlIvw5L7lKN?usp=sharing",
    type:"projects"
  },
  {
  id:4,
  title:"Auto-correct tool",
  date:"Sept 2023",
  description:
  <div>This repository contains my internship task about creating an automatic correction tool provided by BharatIntern. As instructed, I had to use a Jupyter notebook for the same. <p>In this task, the AI must correct the word or give the word which is nearest to it.</p></div>
,image:
"https://res.cloudinary.com/dj24clwc2/image/upload/v1718791956/auto_xerfbq.png",
tags:["Python","Word corrector tool"],
category:"aiml",
github:"https://github.com/samruddhi4040/BharatIntern_Auto-Correct-Tool",
webapp:"https://colab.research.google.com/drive/145y52iHSvb8_B6MUGi-ucGs-qAy0gxhj?usp=sharing",
type:"projects"
  },
  {
    id:5,
    title:"Email Spam Detection",
    date:"Sept 2023",
    description:
    <div>We’ve all been the recipient of spam emails before. <p>Spam mail, or junk mail, is a type of email that is sent to a massive number of users at one time, frequently containing cryptic messages, scams, or most dangerously, phishing content.</p><p> In this project, I've used Python to build an email spam detector. Then, used machine learning to train the spam detector to recognize and classify emails into spam and non-spam. </p>I've also uploaded the dataset used by me.</div>
  ,image:
  "https://res.cloudinary.com/dj24clwc2/image/upload/v1718795912/email_o7xdls.png",
  tags:["NLP","Text Classification","Spam filtering"],
  category:"data science",
  github:"https://github.com/samruddhi4040/Oasis-Infobyte_Email-spam-detection-with-machine-learning-",
  webapp:"https://colab.research.google.com/drive/1c1UWniQTn73nrRm6ycIvgulFXVOUbd89?usp=sharing",
  type:"projects"
    },
    {
      id:6,
      title:"Car price prediction",
      date:"Oct 2023",
      description:
      <div>The price of a car depends on a lot of factors like the goodwill of the brand of the car, features of the car, horsepower and the mileage it gives and many more. <p>Car price prediction is one of the major research areas in machine learning. I've made use of libraries such as pandas (to read in dataset files), numpy (to work with arrays used within the code), matplotlib & seaborn (for plotting), sklearn (for various ML models).</p><p> To train the car price, the decision tree 'regression algorithm' prediction model was used. The data was split into training and test sets to train the model.</p> <p>I've also added the dataset used by me.</p></div>,
    image:
    "https://res.cloudinary.com/dj24clwc2/image/upload/v1718864791/car_price_rkak2w.png",
    tags:["Prediction","ML"],
    category:"data science",
    github:"https://github.com/samruddhi4040/Oasis-Infobyte_Car-price-prediction-with-ML",
    webapp:"https://colab.research.google.com/drive/1VphErIfe2QCTUhy1GilckLucaKVDUi8B?usp=sharing",
    type:"projects"
      },
      {
        id:7,
        title:"Iris flower detection",
        date:"Nov 2023",
        description:
        <div>Iris flower has three species : Setosa, Versicolor and Virginica, which differs according to their measurements. <p>Now using the provided dataset, I checked the measurements of the iris flowers according to their species.</p><p> My task here was to train a machine learning model that can learn from the measurements of the iris species and classify them. I've also added the dataset used by me for ready reference.</p><p> IDE used : Jupyter notebook</p></div>,
      image:
      "https://res.cloudinary.com/dj24clwc2/image/upload/v1718956495/iris_ivgdsm.png",
      tags:["Classification Model",
"Supervised Learning",
"Data Science"],
      category:"data science",
      github:"https://github.com/samruddhi4040/Oasis-Infobyte_Iris-flower-detection/tree/main",
      webapp:"https://colab.research.google.com/drive/1yesyEDY8gW1z2t4qLtzlz1GH41sPGfRQ?usp=sharing",
      type:"projects"
        },
        {
          id:8,
          title:"EDA Student Data Analysis",
          date:"Nov 2023",
          description:
          "This is an EDA on student's data score. The dataset contains rows such as ID, class, gender, race, GPA, Algebra, Calculus1, Calculus2, Statistics, Probability, Measure, functional analysis. I also generated various statistical charts based on the data. I've even uploaded the dataset used by me for ease of access. The code was written in Kaggle notebook.",
        image:
        "https://res.cloudinary.com/dj24clwc2/image/upload/v1718965034/eda_students_ncivff.png",
        tags:["Student Data Analysis",
"Data Visualization",
"Statistical Analysis"],
        category:"data analysis",
        github:"https://github.com/samruddhi4040/EDA-Student-Data-Analysis",
        webapp:"https://www.kaggle.com/code/samruddhi4040/eda-students-data-analysis",
        type:"projects"
          },
          {
            id:9,
            title:"EDA Covid-19",
            date:"Nov 2023",
            description:
            "I performed EDA on Covid 19 reports. The dataset contains rows such as :Province/State, Country/Region, Lat, Long, Date, Confirmed, Deaths, Recovered, Active, WHO Region. I also generated various statistical charts based on the data. I've even uploaded the dataset used by me for ease of access. The code was written in Kaggle notebook.",
          image:
          "https://res.cloudinary.com/dj24clwc2/image/upload/v1718968502/covid_fzvrqq.png",
          tags:["Covid-19 Data Analysis",
"Data Visualization",
"Pandemic Data"],
          category:"data analysis",
          github:"https://github.com/samruddhi4040/EDA-Covid-19",
          webapp:"https://www.kaggle.com/code/samruddhi4040/eda-covid-19",
          type:"projects"
            },
            {
              id:10,
              title:"HR Data Analytics",
              date:"Nov 2023",
              description:
              "Created a Power BI dashboard for online sales data, which you can explore in a live demo here. Key learnings from the project include identifying factors to reduce attrition, improving the hiring process, and enhancing employee productivity and trust. The project includes downloadable datasets, custom wallpapers, and a .pbix file with transformed data for special visualizations.",
            image:
            "https://res.cloudinary.com/dj24clwc2/image/upload/v1726749247/Screenshot_2024-09-19_180347_nwa5bu.png",
            tags:["Sales Analytics",
"Dashboard Design",
"Business Intelligence"],
            category:"power bi",
            github:"https://github.com/samruddhi4040/HR-Data-Analytics-Power-BI",
            webapp:"https://app.powerbi.com/view?r=eyJrIjoiZWJjZjRjZjEtNjM3YS00ZGIwLWExYTUtZjQ2ZDZjZWFlMzAwIiwidCI6ImQ5OTlmMTM5LTY5NzEtNDQzZC1hMTE2LTJmYTBlOWZlZDNhZSJ9",
            type:"projects"
              },
              {
                id:11,
                title:"Online Sales Data",
                date:"Nov 2023",
                description:
                "Created an interactive Power BI dashboard for online sales, featuring advanced visualizations and real-time location mapping with ArcGIS. Uploaded datasets, customization details, and .pbix file for preview.",
              image:
              "https://res.cloudinary.com/dj24clwc2/image/upload/v1726749184/Screenshot_2024-09-19_124755_gqojib.png",
              tags:["PowerBI",
"DataVisualization",
"ArcGIS"],
              category:"power bi",
              github:"https://github.com/samruddhi4040/Online-Sales-Data-Power-BI",
              webapp:"https://app.powerbi.com/view?r=eyJrIjoiZDc1NDY5ZmEtYmEzNC00ZGRmLWFkYzYtZTU1ZmNmOGRlZTgwIiwidCI6ImQ5OTlmMTM5LTY5NzEtNDQzZC1hMTE2LTJmYTBlOWZlZDNhZSJ9",
              type:"projects"
                },
  {
    id: 12,
    title: "QuickCart",
    date: "Dec 2023 - Mar 2024",
    description:
    <div>
    Online Grocery Shopping System made with MERN stack. Users can: create accounts, log in, add/edit reviews, view products, add & delete products from cart, view order history & details. It also includes an admin panel to manage users & products.
    
    <p>The following people have actively contributed in helping me fix bugs and errors within this project:</p>
  </div>
  
    ,image:
      "https://res.cloudinary.com/dj24clwc2/image/upload/v1718692852/335165839-9e16bb0c-1fba-45f8-8d59-026565cb0f28.png_vos9ba.png",
    tags: ["MERN stack", "Web development", "Grocery Shopping System", "Cloudinary"],
    category: "web development",
    github: "https://github.com/samruddhi4040/Online-Grocery-Shopping-System",
    webapp: "https://github.com/samruddhi4040/Online-Grocery-Shopping-System",
    type:"projects",
    member: [
      {
        name: "Harsha Vardhan Jallepali",
        img: "https://res.cloudinary.com/dj24clwc2/image/upload/v1726926874/Screenshot_2024-09-21_192118_fihf02.png",
        linkedin: "https://www.linkedin.com/in/harsha-jallepalli/",
        github: "https://github.com/harshajv7981",
      },
       {
        name: "Indravati Chaurasiya",
        img: "https://res.cloudinary.com/dj24clwc2/image/upload/v1726988856/IMG_20230201_210355_oq3fcy.jpg",
        linkedin: "https://www.linkedin.com/in/indravati-chaurasiya-b664a423a/",
        github: "https://github.com/Indravati",
      }, 
      {
        name: "Prem Rathod",
        img: "https://res.cloudinary.com/dj24clwc2/image/upload/v1726986520/Screenshot_2024-09-22_115816_u7mqnr.png",
        linkedin: "https://www.linkedin.com/in/prem-arun-rathod/",
        github: "https://github.com/PRathod27",
      },
      {
        name: "NandhaKumar Chinnasami",
        img: "https://res.cloudinary.com/dj24clwc2/image/upload/v1726927308/Screenshot_2024-09-21_193125_dadjmm.png",
        linkedin: "https://www.linkedin.com/in/nandhakumar-chinnasami/",
        github: "https://github.com/N4NDH4KUM4R",
      },
      {
        name: "Amey Gaikar",
        img: "https://res.cloudinary.com/dj24clwc2/image/upload/v1726988022/Screenshot_2024-09-22_122324_bcydd7.png",
        linkedin: "https://www.linkedin.com/in/amey-gaikar-3429842b5/",
        github: "https://github.com/AmeyGaikar",
      },
      {
        name: "Ashutosh Pathak",
        img: "https://res.cloudinary.com/dj24clwc2/image/upload/v1726996152/Screenshot_2024-09-22_143804_sfa1fx.png",
        linkedin: "https://www.linkedin.com/in/ashutosh-pathak-y03m10d17/",
        github: "https://github.com/Anonymuscoder",
      },
    ],
  },
  {
    id:13,
    title:"EDA Heart Attack Analysis & Predictions",
    date:"Nov 2023",
    description:
    "Performed EDA on a Heart Attack dataset using Kaggle, which included data understanding, cleaning, and generating statistical charts. Checked for uniqueness, null values, and removed redundancies.",
  image:
  "https://res.cloudinary.com/dj24clwc2/image/upload/v1726654653/Screenshot_2024-09-18_154715_rrjujm.png",
  tags:["EDA",
"HealthData",
"DataCleaning"],
  category:"data analysis",
  github:"https://github.com/samruddhi4040/EDA-Heart-Attack-Analysis",
  webapp:"https://www.kaggle.com/code/samruddhi4040/eda-heart-attack-analysis-prediction",
  type:"projects"
    },
    {
      id:14,
      title:"Bengaluru Real Estate Price Prediction Project",
      date:"Dec 2023",
      description:
      "As part of my Data Science Roadmap, I selected and analyzed a real estate dataset to predict house prices in Bengaluru. The dataset was cleaned and processed for predictive modeling using data from Kaggle.",
    image:
    "https://res.cloudinary.com/dj24clwc2/image/upload/v1726654937/Screenshot_2024-09-18_155207_fedj4x.png",
    tags:["PricePrediction",
"RealEstate",
"MachineLearning"],
    category:"data science",
    github:"https://github.com/samruddhi4040/Bengaluru-Real-Estate-Price-Prediction-Project",
    webapp:"https://www.kaggle.com/code/samruddhi4040/bengaluru-real-estate-price-prediction-project",
    type:"projects"
      },
];
export const achievements = [
  {
    id: 16,
    title: "AI/ML for Geodata Analysis ",
    date: "Sept 2024",
    description: "Indian Institute of Remote Sensing (IIRS) Dehradun, Indian Space Research Organization (ISRO) launched this course on 'Geodata Analysis for AI/ML'. This course dived right from intro upto ML, Deep Learning with RNN, CNN, ML through Google Earth Engine & Python for ML/DL models. Also, special appreciation to the user-friendly LMS portal of ISRO. It was definitely a fun & engaging week to learn things with a fresh perspective.💖",
    image:
      "https://res.cloudinary.com/dj24clwc2/image/upload/v1725253206/Screenshot_2024-09-02_102942_stq0ri.png",
    tags: [
      "ISRO","IIRS Dehradun",
    ],
    category: "other",
    type:"achievements"
  },
 
  {
    id: 14,
    title: "BCG Strategy Consulting Job Simulation",
    date: "Jul 2024",
    description:
      <div>I completed a customer churn analysis simulation for XYZ Analytics as part of the BCG Data Science Job Simulation on Forage. <p>This project showcased my advanced data analytics skills and strategic investigation approach.</p><p> I conducted efficient data analysis using Python, employing Pandas and NumPy, and utilized data visualization techniques to interpret trends. </p>I engineered and optimized a random forest model, achieving an 85% accuracy rate in predicting customer churn.<p> Additionally, I delivered a concise executive summary with actionable insights for informed decision-making.</p></div>,
    image:
      "https://res.cloudinary.com/dj24clwc2/image/upload/v1720678421/bcg_rydjzv.png",
    tags: [
      "BCG","Forage",
    ],
    category: "other",
    type:"achievements"
  },
  {
    id: 15,
    title: "Smack-D-Bug ",
    date: "Feb 2024",
    description: 
    <div>Secured 2nd place in Java debugging contest held in my college by the department of Information Technology.
<p>The contest included 3 rounds (with 4 questions and 30 minutes for each round) where Java codes were to be analyzed for their errors, mark them out, write down their corrections which will generate correct outputs.</p></div>,
    image:
      "https://res.cloudinary.com/dj24clwc2/image/upload/v1727257944/1707237773661_v8wbl8.jpg",
    tags: [
      "Java","Debugging",
    ],
    category: "other",
    type:"achievements"
  },
  {
    id: 13,
    title: "Data Science Intern",
    date: "Dec 2023 - Jan 2024",
    description:
    "Worked as a Data Science Intern and: 1. Built machine learning models for car price prediction and email spam detection. 2. Analyzed and cleaned regional data to determine unemployment rates. 3. Developed an iris species classifier using machine learning techniques.",
    image:
      "https://res.cloudinary.com/dj24clwc2/image/upload/v1719992854/Your_paragraph_text_icjfum.png",
    tags: [
      "Oasis Infobyte",
    ],
    category: "internships",
    type:"achievements",
  },
  {
    id: 12,
    title: "Python Development Intern",
    date: "Aug 2023 - Oct 2023",
    description:
      "Worked as a Python Intern and: 1.Developed a URL shortener in Python using a random string generator. 2.Created a music player with Pygame and Tkinter, supporting play, pause, and stop functions for user-defined playlists.",
    image:
      "https://res.cloudinary.com/dj24clwc2/image/upload/v1717072889/1_qnbiea.png",
    tags: [
      "Code Clause",
    ],
    category: "internships",
    type:"achievements"
  },
  {
    id: 11,
    title: "Data Visualization with Effective Insights",
    date: "Nov 2022 - Jul 2023",
    description:
      " I completed the Tata Data Visualization Job Simulation on Forage. Created data visualizations for Tata Consultancy Services, prepared questions for a meeting with client senior leadership, and developed visuals to aid executives in effective decision-making.",
    image:
      "https://res.cloudinary.com/dj24clwc2/image/upload/v1720611704/tata_xpmf12.png",
    tags: [
      "Forage","Tata",
    ],
    category: "other",
    type:"achievements"
  },
  {
    id: 10,
    title: "Hotstar Clone Bootcamp",
    date: "Jul 2023",
    description:
      "During the 7 day bootcamp of Hotstar Clone, emphasis was made on using HTML, CSS and JavaScript for the same. It was fruitful to learn new aspects of web-dev by the founder @Shaurya Sinha himself during the bootcamp. ",
    image:
      "https://res.cloudinary.com/dj24clwc2/image/upload/v1720611705/goo_vbjwko.png",
    tags: [
      "GDSC","DevTown",
    ],
    category: "other",
    type:"achievements"
  },
  {
    id: 9,
    title: "Agile Methodology Virtual Experience Program",
    date: "Nov 2022 - Jul 2023",
    description:
      "I participated in the Cognizant Agile Methodology Job Simulation on Forage. I created a comprehensive presentation analyzing the strengths and weaknesses of Agile and Waterfall methodologies, identified user stories for an interplanetary video-conferencing application, and documented Scrum role assignments and ceremonies. Additionally, I demonstrated problem-solving skills by diagnosing and proposing solutions for development process issues encountered during sprints.",
    image:
      "https://res.cloudinary.com/dj24clwc2/image/upload/v1720611704/cog_rncqmp.png",
    tags: [
      "Cognizant","Forage",
    ],
    category: "other",
    type:"achievements"
  },
  {
    id: 8,
    title: "AI Intern",
    date: "May 2023 - Aug 2023",
    description:
      "As an AI intern: 1.Developed an AI-powered tool for automatic word correction and replacement. 2.Created an AI translator for seamless language translation.",
    image:
      "https://res.cloudinary.com/dj24clwc2/image/upload/Screenshot_2024-06-18_171200_jj7co4.png",
    tags: [
      "Bharat Intern",
    ],
    category: "internships",
    type:"achievements"
  },
  {
    id: 7,
    title: "AI Intern",
    date: "Jan 2023 - May 2023",
    description:
      "As an Infosys Springboard Intern: 1.Created HONQPGen, an AI-based tool for generating hands-on question papers. 2.Developed a Python program to parse Java code, extract key elements using AST, and generate UML class diagrams with PlantUML.",
    image:
      "https://res.cloudinary.com/dj24clwc2/image/upload/v1717072739/Image_aa535j.jpg",
    tags: [
      "Infosys Springboard",
    ],
    category: "internships",
    type:"achievements"
  },
  {
    id: 6,
    title: "Computer Vision 101",
    date: "Nov 24, 2022",
    description:
      "Computer Vision 101 was an introductory course covering the basics of computer vision, including image processing, feature detection, object recognition, motion tracking, and 3D vision. It also introduced popular tools like OpenCV and TensorFlow, and includes hands-on projects to apply learned concepts.",
    image:
      "https://res.cloudinary.com/dj24clwc2/image/upload/v1720610494/computer_pmrnpj.png",
    tags: [
      "Infosys Springboard",
    ],
    category: "other",
    type:"achievements"
  },
  {
    id: 5,
    title: "Explore Machine Learning using Python",
    date: "Nov 27, 2022",
    description:
      "This was an introductory course teaching the basics of machine learning, covering supervised and unsupervised learning, data preprocessing, model building, and essential Python libraries like NumPy, pandas, and scikit-learn.",
    image:
      "https://res.cloudinary.com/dj24clwc2/image/upload/v1720610494/ml_ze9owt.png",
    tags: [
      "Infosys Springboard",
    ],
    category: "other",
    type:"achievements"
  },
  {
    id: 4,
    title: "Regression Analysis",
    date: "Nov 28, 2022",
    description:
      "This course provided an in-depth exploration of statistical methods used to study relationships between variables. It covered linear and nonlinear regression models, diagnostic techniques, model selection, and interpretation of results. Practical applications included predicting outcomes based on data and understanding factors influencing variables of interest.",
    image:
      "https://res.cloudinary.com/dj24clwc2/image/upload/v1720610513/regression_eq2nqm.png",
    tags: [
      "Infosys Springboard",
    ],
    category: "other",
    type:"achievements"
  },
  {
    id: 3,
    title: "Time Series Analysis",
    date: "Dec 5, 2022",
    description:
      "This course emphasized to learn statistical methods to analyze and forecast time-ordered data, enabling predictions and informed decisions based on historical trends.",
    image:
      "https://res.cloudinary.com/dj24clwc2/image/upload/v1720610512/time_p6lxmw.png",
    tags: [
      "Infosys Springboard",
    ],
    category: "other",
    type:"achievements"
  },
  {
    id: 2,
    title: "Exploratory Data Analysis",
    date: "Dec 14, 2022",
    description:
      "This course covered techniques to analyze data sets, understand their main characteristics, and uncover patterns and relationships. It involved using statistical graphics and other data visualization methods to summarize data, identify trends, and prepare for further modeling or hypothesis testing.",
    image:
      "https://res.cloudinary.com/dj24clwc2/image/upload/v1720610494/data_analysis_rn8or6.png",
    tags: [
      "Infosys Springboard",
    ],
    category: "other",
    type:"achievements"
  },
  {
    id: 1,
    title: "Data Visualization using Python",
    date: "Dec 31, 2022",
    description:
      "This course covered principles and techniques for creating effective visual representations of data. It included topics like data exploration, chart types, color theory, storytelling with data, and tools such as Tableau or matplotlib. Hands-on projects involved creating dashboards and infographics to communicate insights clearly.",
    image:
      "https://res.cloudinary.com/dj24clwc2/image/upload/v1720610494/visualization_gs4slv.png",
    tags: [
      "Infosys Springboard",
    ],
    category: "other",
    type:"achievements"
  },
  {
    id: 0,
    title: "Association Analysis using Python",
    date: "Dec 31, 2022",
    description:
      "This course taught techniques for discovering relationships and patterns in large datasets. It covered algorithms like Apriori and FP-Growth for mining frequent itemsets and association rules. I had learnt to apply these methods to real-world datasets, gaining skills in market basket analysis, recommendation systems, and understanding customer behavior.",
    image:
      "https://res.cloudinary.com/dj24clwc2/image/upload/v1720610494/associate_vbyjoy.png",
    tags: [
      "Infosys Springboard",
    ],
    category: "other",
    type:"achievements"
  },
];
